import { getConsentDocument, acceptConsent } from "@/app/_actions/consent";

/**
 * Client-side utility to fetch the consent document
 * @param type The type of consent document to fetch ('onboarding' or 'address')
 * @returns Promise containing the consent document
 */
export const fetchConsentDocument = async (
	type: ConsentType = "onboarding",
): Promise<ConsentDocument | null> => {
	try {
		return await getConsentDocument(type);
	} catch (error) {
		console.error(`Error fetching ${type} consent document:`, error);
		return null;
	}
};

/**
 * Client-side utility to accept a consent document
 * @param consentDocumentId ID of the consent document to accept
 * @returns Promise with the result of the consent acceptance
 */
export const submitConsentAcceptance = async (
	consentDocumentId: string,
): Promise<{
	success: boolean;
	data?: AcceptConsentResponse;
	error?: string;
}> => {
	try {
		const result = await acceptConsent(consentDocumentId);

		if (result.success) {
			return {
				success: true,
				data: result.data,
			};
		}

		return {
			success: false,
			error: result.errorText,
		};
	} catch (error) {
		console.error("Error accepting consent:", error);
		return {
			success: false,
			error:
				"An unexpected error occurred while accepting the consent document.",
		};
	}
};
